// apps/client/src/modules/Shortcuts/useShortcutMatcher.ts
import { useEffect } from 'react'
import { useStore } from 'jotai'
import {
  eventMatchesShortcut,
  shortcutRegistryAtom,
} from './ShortcutRegistry'

const EDITOR_SELECTORS =
  'input, textarea, [contenteditable="true"], .cm-content, .monaco-editor'

const isInsideEditor = (target: EventTarget | null): boolean => {
  if (!(target instanceof Element)) return false
  return !!target.closest(EDITOR_SELECTORS)
}

/**
 * Mount once at Workspace.tsx. Listens at the window level for keydown events
 * and dispatches the first matching non-displayOnly registry entry. When focus
 * is in an editor/input, only definitions with `firesInEditor: true` fire.
 */
export const useShortcutMatcher = (): void => {
  const store = useStore()

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      const registry = store.get(shortcutRegistryAtom)
      const inEditor = isInsideEditor(e.target)

      for (const def of Object.values(registry)) {
        if (def.displayOnly) continue
        if (!def.handler) continue
        if (!eventMatchesShortcut(e, def)) continue
        if (inEditor && !def.firesInEditor) continue
        e.preventDefault()
        def.handler(e)
        return
      }
    }

    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [store])
}
